module.exports = __webpack_public_path__ + "img/shibboleth.07a15bc8.svg";